import { Component } from '@angular/core';

@Component({
  selector: 'app-client-profile-tabs-skeleton',
  templateUrl: './client-profile-tabs-skeleton.component.html',
  styleUrls: ['./client-profile-tabs-skeleton.component.scss'],
})
export class ClientProfileTabsSkeletonComponent {}
